import React from 'react';
import "./NotFound.css";
const NotFound = () => {
    return (
        <div className="not-found">
            <h1>The Page You Are Looking for Is Not Found....!!404</h1>
        </div>
    );
};

export default NotFound;